/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TransportMethodOptionDto } from './TransportMethodOptionDto';
import {
    TransportMethodOptionDtoFromJSON,
    TransportMethodOptionDtoFromJSONTyped,
    TransportMethodOptionDtoToJSON,
    TransportMethodOptionDtoToJSONTyped,
} from './TransportMethodOptionDto';

/**
 * 
 * @export
 * @interface WarehouseTransportMethodsDto
 */
export interface WarehouseTransportMethodsDto {
    /**
     * 仓库ID
     * @type {number}
     * @memberof WarehouseTransportMethodsDto
     */
    warehouseId?: number;
    /**
     * 仓库中文名称
     * @type {string}
     * @memberof WarehouseTransportMethodsDto
     */
    warehouseNameCn?: string;
    /**
     * 仓库韩文名称
     * @type {string}
     * @memberof WarehouseTransportMethodsDto
     */
    warehouseNameKr?: string;
    /**
     * 仓库配置的运输方式列表
     * @type {Array<TransportMethodOptionDto>}
     * @memberof WarehouseTransportMethodsDto
     */
    transportMethods?: Array<TransportMethodOptionDto>;
}

/**
 * Check if a given object implements the WarehouseTransportMethodsDto interface.
 */
export function instanceOfWarehouseTransportMethodsDto(value: object): value is WarehouseTransportMethodsDto {
    return true;
}

export function WarehouseTransportMethodsDtoFromJSON(json: any): WarehouseTransportMethodsDto {
    return WarehouseTransportMethodsDtoFromJSONTyped(json, false);
}

export function WarehouseTransportMethodsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WarehouseTransportMethodsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
        'warehouseNameCn': json['warehouseNameCn'] == null ? undefined : json['warehouseNameCn'],
        'warehouseNameKr': json['warehouseNameKr'] == null ? undefined : json['warehouseNameKr'],
        'transportMethods': json['transportMethods'] == null ? undefined : ((json['transportMethods'] as Array<any>).map(TransportMethodOptionDtoFromJSON)),
    };
}

export function WarehouseTransportMethodsDtoToJSON(json: any): WarehouseTransportMethodsDto {
    return WarehouseTransportMethodsDtoToJSONTyped(json, false);
}

export function WarehouseTransportMethodsDtoToJSONTyped(value?: WarehouseTransportMethodsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'warehouseId': value['warehouseId'],
        'warehouseNameCn': value['warehouseNameCn'],
        'warehouseNameKr': value['warehouseNameKr'],
        'transportMethods': value['transportMethods'] == null ? undefined : ((value['transportMethods'] as Array<any>).map(TransportMethodOptionDtoToJSON)),
    };
}

